import { observable, computed, runInAction } from 'mobx'
import keyBy from 'lodash/keyBy'
import api from '../api'

class Websites {
  @observable websites = {}
  @observable loaded = false
  @observable currentId
  @observable currentWebsiteData = {}

  @computed get current() {
    return this.currentId && this.websites[this.currentId]
  }

  @computed get count() {
    return Object.keys(this.websites).length
  }

  setCurrent(id) {
    if (!this.websites[id]) {
      this.currentId = id
      return
    }

    api.get('websites/search_config', { params: { website_uuid: this.websites[id].uuid } }).then(resp => {
      runInAction(() => {
        this.currentId = id
        this.currentWebsiteData = resp.data
        this.websites[id].data = resp.data
      })
    })
  }

  load(id) {
    api.get('websites')
      .then(({data}) => {
        runInAction(() => {
          this.loaded = true
          this.websites = keyBy(data, 'id')
          if (id) {
            if (this.currentId === id) {
              // We just cleared out the data for the current website
              // So let's throw the old data back on the current before
              // it reloads so it isn't an empty object and already rendered
              // components that rely on it, don't break while waiting for
              // it to refetch.
              this.websites[id].data = this.currentWebsiteData
            } 
            this.setCurrent(id)
          }
        })
      })
      .catch(() => { this.loaded = true })
  }

  create(website) {
    return api.post(`websites`, website).then(() => this.load())
  }

  save(changes) {
    return api.put(`websites/${this.currentId}`, changes).then(() => {
      Object.assign(this.current, changes)
    })
  }

  provision(id, installation_uuid) {
    return api.put(`provision/${id}`, { installation_uuid })
  }

  export_leads() {
    return api.post(`websites/${this.currentId}/export_leads`)
  }
}

export default Websites



// WEBPACK FOOTER //
// client/stores/websites.js